export default __webpack_public_path__ + "6e91dbce3993a4fec151338654a28b8a.png";